import { setURLParams } from 'actions';
import LinkLookup from 'components/LinkLookup';
import LoadingIndicator from 'components/LoadingIndicator';
import SelectRedesign from 'components/Select/SelectRedesign';
import { resourceQueryParamName } from 'constants/resourceQueryNames';
import pluralize from 'pluralize';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getActions, getActionsCount, getFetchCommentsLoading } from 'selectors/envelopeActions';
import { getNavParamsByResource } from 'selectors/nav';
import { useSelector } from 'store';

const CommentsHeader: React.FC = () => {
  const dispatch = useDispatch();

  const navParams = useSelector(getNavParamsByResource(resourceQueryParamName.comments));
  const typeFilter = navParams.type as string;
  const offset = parseInt(navParams.offset as string, 10);

  const comments = useSelector(getActions);
  const totalCount = useSelector(getActionsCount);
  const loading = useSelector(getFetchCommentsLoading);

  const options = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'Document',
      value: 'document',
    },
    {
      label: 'Inline',
      value: 'inline',
    },
  ];

  const handleChange = (option: string): void => {
    if (option === 'all') {
      dispatch(
        setURLParams({
          [`${resourceQueryParamName.comments}__comment_type`]: '',
          [`${resourceQueryParamName.comments}__offset`]: '0',
        })
      );
    } else {
      dispatch(
        setURLParams({
          [`${resourceQueryParamName.comments}__comment_type`]: option,
          [`${resourceQueryParamName.comments}__offset`]: '0',
        })
      );
    }
  };

  return (
    <header className="w-full px-6">
      <div className="flex flex-col gap-6">
        <div className="flex flex-row justify-between items-center">
          <div className="flex items-center gap-2">
            <LinkLookup
              routeName="notifications"
              className="border-b-4 border-transparent text-menu-item cursor-pointer pb-1 px-2"
            >
              Notifications
            </LinkLookup>
            <div
              role="button"
              tabIndex={0}
              className="border-b-4 border-litlingo-orange text-menu-item cursor-pointer pb-1 px-2"
            >
              My Comments
            </div>
          </div>
        </div>
        <div className="flex flex-nowrap justify-between h-8">
          <div className="flex flex-row gap-3 items-end">
            <h2 className="text-heading-2">My Comments</h2>
            <div className="w-32">
              <SelectRedesign
                placeholder="Type"
                options={options}
                dataTestid="type-filter"
                onChange={handleChange}
                value={typeFilter}
              />
            </div>
          </div>

          <div className="self-end">
            {loading ? (
              <LoadingIndicator className="ml-2" size="5" />
            ) : (
              <>
                <span className="font-bold">
                  {` ${comments.length === 0 ? 0 : offset + 1}-${offset + comments.length}`}
                </span>
                {` of ${totalCount === 10000 ? '+10,000' : pluralize('Comment', totalCount, true)}`}
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default CommentsHeader;
